import { combineReducers } from "redux";
import listaPedidosLML from "./slices/listaPedidosLML.slice";

const reducer = combineReducers({
  listaPedidosLML,
});

export default reducer;
